import { render, staticRenderFns } from "./EmployeeManager.vue?vue&type=template&id=04c7ee96"
import script from "./EmployeeManager.vue?vue&type=script&lang=js"
export * from "./EmployeeManager.vue?vue&type=script&lang=js"
import style0 from "./EmployeeManager.vue?vue&type=style&index=0&id=04c7ee96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports